export default __webpack_public_path__ + "static/media/flag-2.2f8e7da6.svg";